import cx from 'classnames';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import useLoggedUser from '../../../../../hooks/use-logged-user';
import { TsearchCategoryName } from '../../../../../utils/get-category-names';
import ImageLabel from '../image-label';

import classes from './related.module.css';
const RelatedProduct: FunctionComponent<{
  product: TProductListItem;
  as?: keyof JSX.IntrinsicElements;
  info?: TsearchCategoryName | null;
}> = ({ product, as: As = 'div', info }) => {
  const { t } = useTranslation();
  const user = useLoggedUser();
  const isResaleer = user?.staff.company_type == 'supplier';
  return (
    <div
      className={cx(
        'gtm_product_impressions',
        classes.related,
        'flex w-full flex-col',
        'border-white shadow-[0_0_10px_0_rgba(0,0,0,0.15)]'
      )}
    >
      <ImageLabel
        product={product}
        altImage={'common:images_alt.related_products_alt'}
        info={info}
      />
      <div className="p-4 grid grid-cols-1 gap-[6px]">
        <div
          className={cx(
            'bg-opacity-75',
            'text-base',
            'flex',
            'w-full',
            'items-center'
            //'h-12'
          )}
        >
          <div className={cx(classes.imageLabelText, 'text-left truncate')}>
            <b>{product.car_brand}</b> <span>{product.car_model}</span>{' '}
            <span className="text-sm">{product?.car_version}</span>
            {/*<br />
            product.car_door_nr && (
              <b className='text-sm'>
                {product.car_door_nr} {t('vehicle:doors')}
              </b>
            )*/}
          </div>
        </div>
        <As>
          <div className="truncate">
            <strong>{product.part}</strong>
          </div>
          <small className="truncate block text-sm break-all">
            Ref. {product?.reference || '-'}
          </small>
        </As>
        {isResaleer ? (
          <div className="block text-left flex items-end justify-between">
            <small className="text-red-100 mb-1">
              {t('product:resale_price')}
            </small>
            <strong className="text-right">
              {product.pricing?.price_final_printable ||
                t('product:price_on_request')}
            </strong>
          </div>
        ) : (
          <strong className="block text-left flex items-end justify-start">
            {product.pricing?.price_final_printable ? (
              <div>
                <span className="font-extrabold">
                  {product.pricing?.price_final_printable}
                </span>
                <div className="text-xs text-blue-100">
                  <Trans
                    i18nKey={`product:checklist.vat_shipping_${product.pricing.price_message}`}
                    components={{ b: <b /> }}
                  />
                </div>
              </div>
            ) : (
              t('product:price_on_request')
            )}
          </strong>
        )}
      </div>
    </div>
  );
};

export default RelatedProduct;
